import type { FaireProductEntity } from "../../entity_types/product";

export const p_28g9k8jmnw: FaireProductEntity = {
  token: "p_28g9k8jmnw",
  type: "product",
  name: "Vinyl Snob Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/0292283d2bb3fe0ce6d1168f1e16cfc0db1cfee4a8f909038cb460921f4bb3d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce73966e06deb361c5ee4ed63ccb279639a5741087a0199c4173a094622d130f.jpeg",
    "https://cdn.faire.com/fastly/5c26e90a00f723b553f91e78621b6c5393c866146a1ea14eaf3e03bf8af1c0fb.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/c364d288256401673334af0849c7ad3c65432cc6a2520b1c59e98b92d4fa2399.jpeg",
    "https://cdn.faire.com/fastly/625da7fc4c2275f47db7baa38066df0c011147303107c5ad6d76d76b5cc2e2e5.jpeg",
    "https://cdn.faire.com/fastly/6505e39a86c8feda57f2ca82626a82cad6f56cbb0be1a18f3116bb323b2c0861.jpeg"
  ],
  priceDollars: 6.75,
  description: "You can always tell when someone can hear the difference between a cheap Mp3 and the real thing (because they tell you).\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:52.921Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
